import { render } from "./ProductExcelUploadView.vue?vue&type=template&id=7637ae1e&scoped=true"
import script from "./ProductExcelUploadView.vue?vue&type=script&lang=js"
export * from "./ProductExcelUploadView.vue?vue&type=script&lang=js"

import "./ProductExcelUploadView.vue?vue&type=style&index=0&id=7637ae1e&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7637ae1e"]])

export default __exports__